export default __webpack_public_path__ + "static/media/eden.1c9b33ec.svg";